(function () {
  'use strict';

  var CHAIR_CM = 85;
  var CHAIR_RATIO = 52 / 85;

  function parseSize(raw) {
    var text = String(raw || '').replace(/,/g, '.').trim();
    var match = text.match(/(\d+(?:\.\d+)?)\s*[x×X]\s*(\d+(?:\.\d+)?)/);
    if (!match) return null;
    return {
      w: parseFloat(match[1]),
      h: parseFloat(match[2]),
      label: String(Math.round(parseFloat(match[1]))) + '×' + String(Math.round(parseFloat(match[2])))
    };
  }

  function uniqueSorted(list) {
    var seen = {};
    var out = [];
    (list || []).forEach(function (raw) {
      var parsed = parseSize(raw);
      if (!parsed) return;
      var key = parsed.w + 'x' + parsed.h;
      if (seen[key]) return;
      seen[key] = true;
      out.push(parsed);
    });
    out.sort(function (a, b) {
      if (a.h !== b.h) return a.h - b.h;
      return a.w - b.w;
    });
    return out;
  }

  function blobToList(blob) {
    return String(blob || '')
      .split('|')
      .map(function (part) {
        return part.trim();
      })
      .filter(Boolean);
  }

  function cardSizeValues(card) {
    var values = [];
    if (!card) return values;
    card.querySelectorAll('input[name^="set-size-"]').forEach(function (input) {
      if (input.value) values.push(input.value);
    });
    return values;
  }

  function sharedSizesFromChips(setRoot) {
    var cards = setRoot.querySelectorAll('.set-member-controls');
    var lists = [];
    cards.forEach(function (card) {
      var keys = [];
      cardSizeValues(card).forEach(function (raw) {
        var parsed = parseSize(raw);
        if (parsed) keys.push(parsed.w + 'x' + parsed.h);
      });
      if (keys.length) lists.push({ raw: cardSizeValues(card), keys: keys });
    });
    if (!lists.length) return [];
    return lists[0].raw.filter(function (raw) {
      var parsed = parseSize(raw);
      if (!parsed) return false;
      var key = parsed.w + 'x' + parsed.h;
      return lists.every(function (list) {
        return list.keys.indexOf(key) !== -1;
      });
    });
  }

  function sizesFromSet(setRoot) {
    if (!setRoot) return [];
    if (setRoot.classList.contains('is-sync-on')) {
      var shared = sharedSizesFromChips(setRoot);
      if (shared.length) return shared;
    }
    var card = setRoot.querySelector('.set-member-controls.is-active');
    if (!card) card = setRoot.querySelector('.set-member-controls');
    return cardSizeValues(card);
  }

  function sizesFromPdp() {
    var field =
      document.querySelector('[data-option-handle="boyut"]') ||
      document.querySelector('[data-option-handle="size"]') ||
      document.querySelector('[data-option-handle="olcu"]') ||
      document.querySelector('[data-option-handle="beden"]');
    if (!field) return [];
    var values = [];
    field.querySelectorAll('input[type="radio"]').forEach(function (input) {
      if (input.value) values.push(input.value);
    });
    if (values.length) return values;
    field.querySelectorAll('[data-value]').forEach(function (el) {
      if (el.getAttribute('data-value')) values.push(el.getAttribute('data-value'));
    });
    return values;
  }

  function currentSizes(root) {
    var mode = root.getAttribute('data-olcu-mode') || 'pdp';
    var fallback = blobToList(root.getAttribute('data-olcu-sizes'));
    if (mode === 'set') {
      var setRoot = root.closest('[data-duvar-set]') || document.querySelector('[data-duvar-set]');
      var fromSet = sizesFromSet(setRoot);
      return uniqueSorted(fromSet.length ? fromSet : fallback);
    }
    var fromPdp = sizesFromPdp();
    return uniqueSorted(fromPdp.length ? fromPdp : fallback);
  }

  function placeBaseline(root) {
    var stage = root.querySelector('[data-olcu-stage]');
    var baseline = root.querySelector('[data-olcu-baseline]');
    var figure = root.querySelector('[data-olcu-chair-figure]');
    if (!stage || !baseline || !figure) return;
    var stageBox = stage.getBoundingClientRect();
    var figBox = figure.getBoundingClientRect();
    if (!stageBox.width || !figBox.height) return;
    baseline.style.top = Math.round(figBox.bottom - stageBox.top) + 'px';
  }

  function render(root) {
    var items = root.querySelector('[data-olcu-items]');
    var chairItem = root.querySelector('[data-olcu-chair-item]');
    var chairFigure = root.querySelector('[data-olcu-chair-figure]');
    var stage = root.querySelector('[data-olcu-stage]');
    if (!items || !chairItem || !chairFigure || !stage) return;

    var chairCm = parseFloat(root.getAttribute('data-olcu-chair')) || CHAIR_CM;
    var sizes = currentSizes(root);
    var maxH = chairCm;
    sizes.forEach(function (size) {
      if (size.h > maxH) maxH = size.h;
    });

    var availW = stage.clientWidth || root.clientWidth || 360;
    var isMobile = window.matchMedia('(max-width: 749px)').matches || availW < 480;
    var gap = isMobile ? 4 : 14;
    var widthCm = chairCm * CHAIR_RATIO;
    sizes.forEach(function (size) {
      widthCm += size.w;
    });
    var gaps = Math.max(0, sizes.length) * gap;
    var sidePad = isMobile ? 2 : 12;
    var pxFromWidth = (availW - gaps - sidePad) / Math.max(widthCm, 1);
    var pxFromHeight = Math.min(168, Math.max(isMobile ? 78 : 118, availW * (isMobile ? 0.26 : 0.36))) / maxH;
    var px = Math.max(0.35, Math.min(pxFromWidth, pxFromHeight));

    chairFigure.style.width = Math.max(22, Math.round(chairCm * CHAIR_RATIO * px)) + 'px';
    chairFigure.style.height = Math.round(chairCm * px) + 'px';

    items.querySelectorAll('[data-olcu-box]').forEach(function (node) {
      node.remove();
    });

    sizes.forEach(function (size) {
      var item = document.createElement('div');
      item.className = 'olcu-rehberi__item';
      item.setAttribute('data-olcu-box', '');
      item.setAttribute('data-w', String(size.w));
      item.setAttribute('data-h', String(size.h));

      var box = document.createElement('span');
      box.className = 'olcu-rehberi__figure olcu-rehberi__box';
      box.setAttribute('aria-hidden', 'true');
      box.style.width = Math.max(8, Math.round(size.w * px)) + 'px';
      box.style.height = Math.max(8, Math.round(size.h * px)) + 'px';

      var label = document.createElement('span');
      label.className = 'olcu-rehberi__label';
      label.textContent = size.label;

      item.appendChild(box);
      item.appendChild(label);
      items.appendChild(item);
    });

    requestAnimationFrame(function () {
      var used = items.scrollWidth;
      if (used > availW + 1 && px > 0.35) {
        px *= availW / used;
        chairFigure.style.width = Math.max(18, Math.round(chairCm * CHAIR_RATIO * px)) + 'px';
        chairFigure.style.height = Math.round(chairCm * px) + 'px';
        items.querySelectorAll('[data-olcu-box]').forEach(function (node) {
          var w = parseFloat(node.getAttribute('data-w')) || 0;
          var h = parseFloat(node.getAttribute('data-h')) || 0;
          var box = node.querySelector('.olcu-rehberi__box');
          if (!box) return;
          box.style.width = Math.max(6, Math.round(w * px)) + 'px';
          box.style.height = Math.max(6, Math.round(h * px)) + 'px';
        });
      }
      placeBaseline(root);
    });
  }

  function bind(root) {
    if (!root || root.dataset.olcuBound === '1') return;
    root.dataset.olcuBound = '1';
    render(root);

    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(function () {
        render(root);
      });
      ro.observe(root);
      var stage = root.querySelector('[data-olcu-stage]');
      if (stage) ro.observe(stage);
    }

    var modal = root.closest('.info-popup, modal-dialog');
    if (modal && typeof MutationObserver === 'function') {
      var mo = new MutationObserver(function () {
        if (modal.hasAttribute('open')) render(root);
      });
      mo.observe(modal, { attributes: true, attributeFilter: ['open'] });
    }
  }

  function refreshAll() {
    document.querySelectorAll('[data-olcu-rehberi]').forEach(render);
  }

  function init(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll ? root.querySelectorAll('[data-olcu-rehberi]') : [];
    if (root.matches && root.matches('[data-olcu-rehberi]')) nodes = [root];
    Array.prototype.forEach.call(nodes, bind);
  }

  window.AlalartOlcuRehberi = {
    refresh: refreshAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('alalart:olcu-rehberi-update', refreshAll);
  window.addEventListener('resize', refreshAll);

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) init(event.target);
  });
})();
